import { render, staticRenderFns } from "./WorksheetView.vue?vue&type=template&id=187cda4a&scoped=true&"
import script from "./WorksheetView.vue?vue&type=script&lang=js&"
export * from "./WorksheetView.vue?vue&type=script&lang=js&"
import style0 from "./WorksheetView.vue?vue&type=style&index=0&id=187cda4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187cda4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})
